import Form from "react-bootstrap/Form";
import "../../../src/main.css";
import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom";

import Offcanvas from "react-bootstrap/Offcanvas";
import NewWindowLogo from "assets/img/illustrations/NewWindowLogo";

function OffCanvas({ name, ...props }) {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <div variant="primary"  className="me-2">

          <div className="d-flex ">
          <OverlayTrigger
          overlay={
            <Tooltip style={{ position: "fixed" }} id="overlay-trigger-example">
              <div className="fw-bold"> Click to view Events</div>
            </Tooltip>
          }
        >
          <div onClick={handleShow} className="cursor-pointer pe-3" >

            {" "}
            <NewWindowLogo />

          </div>
          </OverlayTrigger>
          <Link to={`/lead-details/${props?.record?.user?.case_id}`} className="text-primary mx-1">
          <OverlayTrigger
          overlay={
            <Tooltip style={{ position: "fixed" }} id="overlay-trigger-example">
              <div className="fw-bold">Lead Details</div>
            </Tooltip>
          }
        >
          <span className="ms-1">{props.userName}</span>
          </OverlayTrigger>
          </Link>
          </div>
        {/* </OverlayTrigger> */}
      </div>
      <Offcanvas
        show={show}
        onHide={handleClose}
        {...props}
        style={{ width: "45%" }}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <h2>Events</h2>
            <hr></hr>
            <h5 className="text-break">{props.userName}</h5>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {
            props.record?.events.map((item)=>{
                return <pre style={{width:"100%"}} className="text-break border-bottom p-2 scrollable-container" >{JSON.stringify(item, null, 2)}</pre>
            })
          }
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

function BookingLoggersModal({ userName, record }) {
  return (
    <>
      <OffCanvas
        key={6}
        userName={userName}
        record={record}
        placement={"end"}
        name={"Filter"}
      />
    </>
  );
}

export default BookingLoggersModal;

